export default "__VITE_ASSET__2e88942f__"